

class EbscoForm {
    constructor(el)
    {
        if(!el.is('form')) {
            return;
        }
        this._el = el;
        this._rawForm = el[0];
        this._catalogSelector = el.find('.catalog-selector');
        this._saraOptions = el.find('.sara-options');
        this._checkboxOptions = el.find('.checkbox-options');
        this._catalogSelector.on('change', this.catalogSelectionChanged.bind(this));
        this._el.on('submit', this.onFormSubmit.bind(this));
    }
    catalogSelectionChanged() {
        let selection  = this._catalogSelector.val();
        if (selection == 'resources') {
            this._checkboxOptions .show();
        }
        else {
            this._checkboxOptions .hide();
        }

        if (selection == 'articles') {
            this._saraOptions.hide();
        }
        else {
            this._saraOptions.show();
        }

        if (selection == 'books') {
            this._checkboxOptions .hide();
        }
        else {
            this._checkboxOptions .show();
        }
    }
    onFormSubmit() {
        var catalog = this._catalogSelector.val();
        this._rawForm.bquery.value = this._rawForm.search_prefix.value + this._rawForm.uquery.value;
        switch (catalog) {
        case 'articles':
            this._checkLimitToArticles();
            this._checkLimitToSara();
            this._checkLimitToFullText();
            break;
        case 'books':
            this._checkLimitToBooks();
            this._checkLimitToSara();
            break;
        case 'resources':
            this._checkLimitToFullText();
            break;
        default:
            break;
        }
    }
    _checkLimitToSara() {
        this._rawForm.clv0.value = this._rawForm.filtersara.checked ?'Y': 'N';
    }
    _checkLimitToArticles() {
        this._rawForm.bquery.value += ' AND ZT Article';
    }
    _checkLimitToBooks() {
        this._rawForm.bquery.value += ' AND PT Book';
    }
    _checkLimitToFullText() {
        this._rawForm.clv0.value = this._rawForm.filterfullText.checked ?'Y': 'N';
    }
}

export default EbscoForm;